export default [
  {
    path: '/apps/uf/list',
    name: 'apps-uf-list',
    component: () => import('@/views/cadastros/gerais/uf/list/Index.vue'),
    meta: {
      pageTitle: 'UF',
      resource: 'AdminHanes',
    },
  },
];
